<template>
    <div id="search">
        <div class="row">
            <div class="col-12 col-md-3 mb-3 position-relative">
                <div id="filters">
                    <h2 class="h5 mb-3">Filter search</h2>
                    <div class="btn btn-outline-dark mb-3"
                        @click="resetFilters"
                        v-show="search
                        || in_stock
                        || priceRange[0] > 0
                        || priceRange[1] < maxPrice
                        || selectedCategories.length
                        || selectedFilters.length
                        || _.find(ranges, function (range) { return range[0] || range[1]})">
                        <i class="fas fa-ban fa-fw"></i> {{t.product.reset_filters}}
                    </div>
                    <div class="input-group mb-3">
                        <input v-model="search" type="text" class="form-control" placeholder="Product name" v-on:keypress.enter="filterResult"
                        v-on:keyup.delete="search == '' ? filterResult() : null">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="filterResult"><i class="fas fa-search"></i></button>
                        </div>
                    </div>
                    <div v-if="showPrice">
                        <div class="lead fw-bold mb-3">{{t.product.price}}</div>
                        <div class="p-4">
                            <vue-slider
                                v-model="priceRange"
                                tooltip="always"
                                :tooltip-placement="['top', 'bottom']"
                                :min="0"
                                :max="maxPrice"
                                :interval="config.currency_decimals ? 0.01 : 1"
                                v-on:drag-end="filterResult"
                                @click.native="filterResult"
                                :enable-cross="false"
                                :tooltip-formatter="tooltipFormatter"
                                :disabled="!loaded"
                            ></vue-slider>
                        </div>
                    </div>
                    <div v-if="config.modules.stock" class="mb-3">
                        <div class="lead fw-bold">{{t.product.stock}}</div>
                        <input id="in_stock" type="checkbox" class="ms-3 me-2" @click="filterResult" v-model="in_stock"><label for="in_stock">
                            {{t.product.in_stock}}
                            <span v-if="loaded && !in_stock" class="ms-2 badge rounded-pill bg-dark">{{nbrInStock}}</span>
                        </label>
                    </div>
                    <div v-if="categories && categories.length">
                        <div class="lead fw-bold mb-2">{{ pageType == 'category' ? t.product.subcategories : t.product.categories}}</div>
                        <div v-for="category in categories" :key="category.id" class="ms-3">
                            <input :id="category.id" type="checkbox" class="me-2"
                            v-model="selectedCategories"
                            :value="category.slug"
                            @change="filterResult"
                            :disabled="!loaded">
                            <label :for="category.id">
                                {{category.name}} <span v-if="!selectedCategories.find((slug) => slug == category.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{category.count}}</span>
                            </label>
                            <div class="ms-3" v-for="subcategory in category.subcategories_has_products" v-bind:key="subcategory.id">
                                <input :id="subcategory.id" type="checkbox" class="me-2"
                                v-model="selectedCategories"
                                :value="subcategory.slug"
                                @change="filterResult"
                                :disabled="!loaded">
                                <label :for="subcategory.id">
                                    {{subcategory.name}} <span v-if="!selectedCategories.find((slug) => slug == subcategory.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{subcategory.count}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div v-if="filters && filters.length" class="mt-3">
                        <div class="mb-2" v-for="filter in filters" :key="filter.id">
                            <div class="lead fw-bold mb-3">{{filter.name}}</div>
                            <div v-if="filter.type == 'numeric'" class="d-flex">
                                <div class="input-group input-group-sm me-3 ms-auto">
                                    <input type="number" :placeholder="t.product.min"
                                    v-model.number="ranges[filter.slug][0]" @change="filterResult" min="0" class="form-control">
                                    <div v-if="filter.unitName" class="input-group-append">
                                        <span class="input-group-text">{{filter.unitName}}</span>
                                    </div>
                                </div>
                                <div class="input-group input-group-sm ms-auto">
                                    <input type="number" :placeholder="t.product.max"
                                    v-model.number="ranges[filter.slug][1]" @change="filterResult" min="0" class="form-control">
                                    <div v-if="filter.unitName" class="input-group-append">
                                        <span class="input-group-text">{{filter.unitName}}</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="filter.type == 'boolean'">
                                <input type="checkbox"
                                    :id="filter.slug"
                                    v-model="booleanFilters"
                                    :value="filter.slug"
                                    @change="filterResult"
                                    :disabled="!loaded"> <label :for="filter.slug">{{filter.name}}</label>
                                    <span class="badge ml-2" v-if="!booleanFilters.find((slug) => slug == filter.slug) && loaded">{{filter.count}}</span>
                            </div>
                            <div v-else-if="filter.type == 'multi'">
                                <div v-for="value in filter.possible_values" :key="value.slug" class="ms-3">
                                    <div>
                                        <input :id="filter.slug+'_'+value.slug" type="checkbox" class="me-2"
                                        v-model="selectedFilters"
                                        :value="filter.slug+'_'+value.slug"
                                        @change="filterResult"
                                        :disabled="!loaded"><label :for="filter.slug+'_'+value.slug">
                                            {{value.name}} <span v-if="!selectedFilters.find((index) => index == filter.slug+'_'+value.slug) && loaded" class="ms-2 badge rounded-pill bg-dark">{{value.count}}</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div v-if="loaded" class="fst-italic mb-2">
                    <b>{{ result.total }}</b> {{t.product.products}}
                </div>
                <!-- <transition-group name="fade" tag="div" class="row"> -->
                    <div class="row">
                        <div v-for="product in products" :key="product.id" class="col-12 col-md-6 col-lg-4 mb-4">
                            <product-block-component :data-product="product"></product-block-component>
                        </div>
                    </div>
                <!-- </transition-group> -->
                <infinite-loading
                    :identifier="infiniteId"
                    spinner="waveDots"
                    @infinite="getResult">
                    <div slot="no-more">{{t.product.loading_no_more_products}}</div>
                    <div slot="no-results">{{ t.product.no_products }}</div>
                </infinite-loading>
            </div>
        </div>
    </div>
</template>

<script>
import store from '../CartStore';
import VueSlider from "vue-slider-component";
import 'vue-slider-component/theme/default.css'
import InfiniteLoading from "vue-infinite-loading";
export default {
    components: {
        VueSlider,
        InfiniteLoading
    },
    store: store,
    data() {
        return {
            t: t,
            config: config,
            pageType: window.page_type,
            selectedCategories: window.params.categories
                ? window.params.categories
                : [],
            selectedFilters: window.params.filters
                ? window.params.filters
                : [],
            booleanFilters: window.params.b_filters
                ? window.params.b_filters
                : {},
            ranges: window.ranges,
            categories: [],
            category: window.category,
            priceRange: window.params.price_range
                ? window.params.price_range
                : [0, window.maxPrice],
            maxPrice: window.maxPrice,
            search: window.params.search,
            in_stock: null,
            result: {},
            nbrInStock: null,
            products: [],
            filters: [],
            page: 1,
            tooltipFormatter: this.amountWithCurrency('{value}', false),
            infiniteId: new Date(),
            loaded: false,
            showPrice: !config.modules.catalog_mode || settings.show_price,
            paginate: 6,
        };
    },
    methods: {
        ...Vuex.mapActions(["addProduct"]),
        addToCart(product) {
            product.qty = 1
            this.addProduct(product)
        },
        resetFilters() {
            this.page = 1;
            this.search = null
            this.in_stock = null
            this.priceRange = [0, window.maxPrice]
            this.selectedCategories = []
            this.selectedFilters = []
            this.booleanFilters = []
            $.each(this.ranges, (index, range) => { this.ranges[index] = [null, null] })
            this.products = []
            if($('#search').length) {
                $('html').animate({ scrollTop: $('#search').offset().top - 150 }, 100)
            }
            this.infiniteId += 1
        },
        filterResult() {
            this.page = 1;
            this.products = []
            if($('#search').length) {
                $('html').animate({ scrollTop: $('#search').offset().top - 150 }, 100)
            }
            this.infiniteId += 1
        },
        getResult($state) {
            this.loaded = false
            axios
            .post("/ajax/search", {
                page: this.page,
                category: this.category ? this.category.slug : null,
                categories: this.selectedCategories,
                filters: this.selectedFilters,
                b_filters: this.booleanFilters,
                ranges: this.ranges,
                search: this.search,
                price_range: this.priceRange,
                in_stock: this.in_stock,
                paginate: this.paginate,
            })
            .then((response) => {
                this.result = response.data.products;
                if (this.result.current_page == 1) {
                    this.changeUrl()
                    this.filters = response.data.filters;
                    this.categories = response.data.categories;
                    this.nbrInStock = response.data.in_stock;
                }
                if (this.result.data.length) {
                    this.page += 1;
                    this.products.push(...this.result.data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
                this.loaded = true
            });
        },
        changeUrl() {
            var url = this.url('products')
            if (this.category) {
                url += '/'+this.category.slug
            }
            var stringQueries = []
            if (this.selectedCategories.length) {
                stringQueries.push('categories='+this.selectedCategories.map(categorySlug => `${categorySlug}`).join(','))
            }
            if (this.booleanFilters.length) {
                stringQueries.push('b_filters='+this.booleanFilters.map(filterSlug => `${filterSlug}`).join(','))
            }
            if (this.selectedFilters.length) {
                var filtersQueryString = {}
                $.each(this.selectedFilters, function(key, values) {
                    var aValues = values.split('_')
                    var attrSlug = aValues[0]
                    var valueSlug = aValues[1]
                    if (filtersQueryString[attrSlug]) {
                        filtersQueryString[attrSlug].push(valueSlug)
                    } else {
                        filtersQueryString[attrSlug] = [valueSlug]
                    }
                })
                $.each(filtersQueryString, function(filterSlug, values) {
                    stringQueries.push('filters['+filterSlug+']='+values.join(','))
                })
            }
            if (this.priceRange && (this.priceRange[0] != '0' || this.priceRange[1] != this.maxPrice.toString())) {
                stringQueries.push(this.priceRange.map(value => `price_range[]=${value}`).join('&'))
            }
            if (Object.keys(this.ranges).length) {
                $.each(this.ranges, function(attributeSlug, value) {
                    if (value[0] || value[1])
                    stringQueries.push(`ranges[${attributeSlug}]=${value[0]},${value[1]}`)
                })
            }
            history.replaceState(
                {},
                null,
                url+(stringQueries.length ? '?'+stringQueries.join('&') : '')
            )
        }
    },
};
</script>
